const MS_IN_DAY = 1000 * 60 * 60 * 24;

function todayMidnightTimestamp(): number {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}

const TODAY_MIDNIGHT_TIMESTAMP = todayMidnightTimestamp();

export function yearsFromNowToDays(years: number): number {
  const endDate = new Date(TODAY_MIDNIGHT_TIMESTAMP);
  endDate.setFullYear(endDate.getFullYear() + years);
  const diff = endDate.getTime() - TODAY_MIDNIGHT_TIMESTAMP;
  return Math.round(diff / MS_IN_DAY);
}
